/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/* 
`<dashboard-user-actions>` shows quick actions for user.

@demo bower_components/speedboat_ui/elements/demo/dashboard-user-info-demo.html
*/
import {
	Polymer,
	html
} from '@polymer/polymer/polymer-legacy.js';
import "../../sb_transfer_ui/elements/biller-details-new.js";

const template = html `
	<style include="app-styles">			
			.min-height{
				min-height:100px;
			}
			.info-card{
				margin:8px;
				padding:8px;
				min-width:320px;
			}
			.info-card[tablet], .info-card[desktop]{
				min-width:0px;
				width:Calc(100% - 16px);
				padding:0px;
				border-radius: 0px !important;
				box-shadow: 0px 0px 0px 0px !important;
			}
			.padding-lr-8px{
				padding-left:8px;
				padding-right: 8px;
			}
			:dir(ltr) .display-text{
				margin-left:18px;
				margin-bottom:-16px;
			}
			:dir(rtl) .display-text{
				margin-right:8px;
				margin-bottom:-16px;
			}
			oe-info{
                font-size:inherit;
                --oe-info-label:{
                   padding:0px;
                }
                --oe-info-value:{
					padding:0px;
                    font-size: var(--a-font-size-xs);
					font-family: var(--medium-font);
                    color: var(--secondary-dark-color);
                }
            }
			::-webkit-scrollbar{
      			height:0px;
       			background: transparent;
			 }	
			 .my-wall-app-fab {
                 	position: absolute;
                    top: 22%;
                }
                .my-wall-display-text {
                    position: relative;
                    left: 10%;
                    top: 14px;
                }
				@media (max-width:479px){									
					#dashboard_info_scroll_div {
						overflow-y:hidden;
						margin-top:-40px;
					}					
					.info-card {
						width: 95%;
						margin: 39px 10px !important;
						padding: 10px 16px 10px 13px;
						min-width: unset !important;
					}					
					.dont-display-in-mobile {
						display:none;
					}
					#my-wall-custom-slider paper-card {
						margin-top: 40px;
					}

					paper-card.round-icon-list-wrapper {
						box-shadow: var(--shadow-elevation-1);		
						border-radius: 11px;
					}					
                    .my-wall-display-text {
                        left: 14%;
                        top: 8px;
                    }                    
                    .currency-formatter-div {
						position: relative;    
						top: -7px;
						left:8px;
					}
					.my-wall-app-fab {
					  left:2.5%;
					}
					.spinner-mobile {
						display:none;
					}
					paper-ripple {
                 		color: var(--field-unchecked-color);
                	}
				}
				@media (min-width:768px){
					.display-mobile {
						display:none;
					}
            	}			
				app-swiper {
					--app-swipe-height: {
						height: 126px;
					}
					--swiper-slide-style: {
						width: 85%;
					}
					--swiper-pagination-position: {
						top: 10px;
						left: 88vw !important;
					}
					--swiper-container: {
						padding-top: 10px; 
						padding-left: 16px;
						padding-right: 16px;                   
					}
				}

            .card-layout {
                width: 290px;
                height: 100px;
            }
        </style>

		<app-media-query desktop={{desktop}} tablet={{tablet}} phone={{phone}}></app-media-query>

		<template is="dom-if" if="{{userInformationAvailable}}">

			<div class="border-b-1px" hidden$={{!phone}}>
			</div>

			<div class="mdl-grid padding-b-zero dont-display-in-mobile" hidden$={{!phone}}>
				<div class="mdl-cell mdl-cell--12-col secondary-dark-text-m font-medium">
					<oe-i18n-msg msgid="h_MyWall"></oe-i18n-msg>
				</div>
			</div>

			<template is="dom-if" if="{{userInformationLoader}}">
				<div class="min-height horizontal center-center layout">
					<paper-spinner id="dashboard_info_spinner" active class="spinner-mobile"></paper-spinner>
				</div>
			</template>

			<template is="dom-if" if="{{!userInformationLoader}}">
				<template is="dom-if" if="{{!phone}}">
					<div class$="{{_addClassBasedOnDevice(phone)}}" id="dashboard_info_scroll_div">						
						<template is="dom-repeat" items="{{finalList}}" as="item">							
							<paper-card class$="{{_addClassBasedOnDeviceToCard(phone)}}" id="dashboard_info_number_{{index}}" tablet$="{{tablet}}" desktop$="{{desktop}}" on-tap="_goToAction">
								<div class$="{{_addClassBasedOnDeviceToDiv(phone)}}">
									<template is="dom-if" if="{{!_checkServiceRequestAndProductApplication(item)}}">
									<div class="vertical layout">
										<div class="outlineOffset horizontal layout" tabindex="0">
											<app-fab name="{{item.displayAppFabName}}" small aria-hidden="true" class="my-wall-app-fab"></app-fab>
											<div class="display-text flex-1 vertical end-justified layout text-overflow-ellipsis my-wall-display-text">
												<div class="text-overflow-ellipsis">
													<span class="font-medium primary-dark-text-m">{{item.displayName}}</span>
													<span class="secondary-dark-text-s">{{item.displaySecondName}}</span>
												</div>
												<span class="secondary-dark-text-xs">{{item.displayRemark}} &nbsp;</span>
												<oe-info type="timestamp" format={{dateFormat}} value = "{{item.displayDate}}"></oe-info>
											</div>
										</div>
										<div class="vertical end layout">
											<div class="font-medium primary-dark-text-m" id="dashboard_info_amount_{{index}}">
												<currency-formator format-value="{{item.displayAmount}}"></currency-formator>
											</div>
											<div class="border-1px border-round-24px padding-lr-8px secondary-dark-text-xs" hidden$={{_checkValue(item.displayTag)}}>{{item.displayTag}}</div>
											<div class="secondary-dark-text-xs" hidden$={{!_checkValue(item.displayTag)}}>&nbsp;</div>
										</div>
									</div>
								</template>
								
                                <template is="dom-if" if="{{_checkExperience(item)}}">
                                    <paper-card class="engagementCard" tablet$="{{tablet}}" desktop$="{{desktop}}">
                                        <div class="vertical layout">
                                            <div class="primary-dark-text-m font-medium">
                                                <span>{{item.data.engagementMetadata.engagementName}}</span>
                                            </div>
                                            <div>
                                                <span><span class="primary-dark-text-s"> {{item.data.engagementMetadata.engagementDescription}}</span></span>
                                            </div>
                                            <template is="dom-if" if="{{item.primary_action}}">
                                                <paper-button on-tap="hanldeEngagementPrimaryClick">{{item.primary_action.name}}</paper-button>
                                            </template>
                                        </div>
                                    </paper-card>
                                </template>							

								<template is="dom-if" if="{{_checkServiceRequest(item)}}">
					<div class="vertical layout">
					<div tabindex="0" class="outlineOffset">
										<div class="primary-dark-text-m font-medium">
											<oe-i18n-msg msgid="l_CheckbookRequest"></oe-i18n-msg>
										</div>
									<!--	<div>
											<span class="secondary-dark-text-s"><oe-i18n-msg msgid="l_EstimatedClosure"></oe-i18n-msg>:</span>
											<oe-info type="timestamp" format={{dateFormat}} value = "{{item.displayDate}}"></oe-info>
										</div>-->
					</div></div>
					
									<app-stepper is-widget$="{{phone}}" tracker-layout="" processing-index="{{getIndex(item.requestStatus.cmCode)}}" progress-array="{{progressSteps(item)}}" ></app-stepper>
								</template>
								<template is="dom-if" if="{{_checkProductApplication(item)}}">
									<template is="dom-repeat" items="{{item.products}}" as="product">
										<div class="vertical layout">
											<div class="primary-dark-text-m font-medium">
												<span><oe-i18n-msg msgid="l_application" ></oe-i18n-msg>&nbsp</span><span>{{product.productName}}</span>
											</div>
											<div>
												<span><oe-i18n-msg msgid="l_appRefNumber" class="secondary-dark-text-s"></oe-i18n-msg><span class="primary-dark-text-s"> {{item.applicationReferenceNumber}}</span></span>
											</div>
											<app-stepper is-widget$="{{phone}}" tracker-layout="" processing-index="{{getStatusIndex(item.applicationStatus)}}" progress-array="{{applicationProgressSteps(item)}}"></app-stepper>
										</div>
									</template>
								</template>
								</div>
							</paper-card>
							

							<div class="mdl-grid mdl-right-no-spacing padding-b-zero padding-t-zero" hidden$={{phone}}>
								<div class="border-b-1px mdl-cell margin-t-zero mdl-cell--12-col" hidden$="{{_checkLastIndex(index,finalList)}}"></div>
							</div>
						</template>
					</div>
				</template>
				<template is="dom-if" if="{{phone}}">
				<p class="font-size-l font-medium mdl-grid mdl-cell margin-t-zero padding-t-zero"><oe-i18n-msg msgid="h_MyWall"></oe-i18n-msg></p>		
					
				
				<div class$="{{_addClassBasedOnDevice(phone)}}" id="dashboard_info_scroll_div">								
						<app-swiper id="my-wall-custom-slider" class="full-width" initial-slide="0" centered-slides-mobile="{{centeredSlidesMobile}}" swiper-pagination={{showSwiperPagination}} space-between-mobile=16
                                    slider-effect="slide" space-between-mobile=0 slides-per-view-mobile=2>
							<template is="dom-repeat" items="{{finalList}}" as="item">							    
								<div>
									<div class="card-layout full-width">						    
										<paper-slide class="full-width">								  	
										<paper-card class$="{{_addClassBasedOnDeviceToCard(phone)}}" id="dashboard_info_number_{{index}}" tablet$="{{tablet}}" desktop$="{{desktop}}" on-tap="_goToAction">
											<div class$="{{_addClassBasedOnDeviceToDiv(phone)}}">									
												<template is="dom-if" if="{{!_checkServiceRequestAndProductApplication(item)}}">
														<div class="content-align-vertical-center justify-content-space-bwn mdl-grid mdl-cell">
														<div class="outlineOffset horizontal layout" tabindex="0">
																<app-fab name="{{item.displayAppFabName}}" small aria-hidden="true" class="my-wall-app-fab mdl-grid padding-t-zero padding-b-zero padding-l-zero"></app-fab>
															<div class="display-text flex-1 vertical end-justified layout text-overflow-ellipsis my-wall-display-text">
																<div class="text-overflow-ellipsis">
																	<span class="font-medium primary-dark-text-m">{{item.displayName}}</span>
																	<span class="secondary-dark-text-s">{{item.displaySecondName}}</span>
																</div>
																<div class="secondary-dark-text-s">{{item.displayRemark}}</div>
																<oe-info type="timestamp" format={{dateFormat}} value = "{{item.displayDate}}"></oe-info>
															</div>
														</div>
															<div class="margin-zero mdl-grid mdl-grid--no-spacing">
															<div class="font-medium primary-dark-text-m currency-formatter-div" id="dashboard_info_amount_{{index}}">
																<currency-formator format-value="{{item.displayAmount}}"></currency-formator>
															</div>
															<div class="border-1px border-round-24px padding-lr-8px secondary-dark-text-xs" hidden$={{_checkValue(item.displayTag)}}>{{item.displayTag}}</div>
															<div class="secondary-dark-text-xs" hidden$={{!_checkValue(item.displayTag)}}>&nbsp;</div>
														</div>
													</div>
												</template>
												<template is="dom-if" if="{{_checkServiceRequest(item)}}">
													<div class="vertical layout">
														<div tabindex="0" class="outlineOffset">
															<div class="primary-dark-text-m font-medium">
																<oe-i18n-msg msgid="l_CheckbookRequest"></oe-i18n-msg>
															</div>
															<!--<div>
																<span class="secondary-dark-text-s custom-secondary-dark-text-s"><oe-i18n-msg msgid="l_EstimatedClosure"></oe-i18n-msg>:</span>
																<oe-info type="timestamp" format={{dateFormat}} value = "{{item.displayDate}}"></oe-info>
															</div>-->
														</div>
													</div>					
													<app-stepper is-widget$="{{phone}}" tracker-layout="" processing-index="{{getIndex(item.requestStatus.cmCode)}}" progress-array="{{progressSteps(item)}}"></app-stepper>
												</template>
												<template is="dom-if" if="{{_checkProductApplication(item)}}">
													<template is="dom-repeat" items="{{item.products}}" as="product">
														<div class="vertical layout">
															<div class="primary-dark-text-m font-medium">
																<span><oe-i18n-msg msgid="l_application" ></oe-i18n-msg>&nbsp</span><span>{{product.productName}}</span>
															</div>
															<div>
																<span><oe-i18n-msg msgid="l_appRefNumber" class="secondary-dark-text-s"></oe-i18n-msg><span class="primary-dark-text-s"> {{item.applicationReferenceNumber}}</span></span>
															</div>
															<app-stepper is-widget$="{{phone}}" tracker-layout="" processing-index="{{getStatusIndex(item.applicationStatus)}}" progress-array="{{applicationProgressSteps(item)}}"></app-stepper>
														</div>
													</template>
												</template>
											</div>
											<paper-ripple class="display-mobile"></paper-ripple> 
										</paper-card>									              					
									</paper-slide>
									</div>
								</div>
							</template>
							</app-swiper>
						</div>
					</template>				
				</template>
				</template>`


Polymer({
	is: "dashboard-user-info",
	_template: template,
	behaviors: [accessibilityBehaviours.commonFunctions, sbBehaviours.retailDashboardBehavior],
	properties: {
		centeredSlidesMobile:{
            type: Boolean,
            value: false,
        },
		loans: {
			type: Array,
			notify: true,
			observer: '_getLoansWithEMINearBy'
		},
		loaneminearby: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		investments: {
			type: Array,
			notify: true,
			observer: '_getDepositNearMaturity'
		},
		depositnearmaturity: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		requests: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		scheduletransactions: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		schedulebills: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		schedulebillspresentment: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		applicationList: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		},
		nextNdays: {
			type: Number,
			notify: true
		},
		userInformationLoader: {
			type: Boolean,
			value: true,
			notify: true,
			observer: 'onUserInformationLoaderChange'
		},
		finalList: {
			type: Array,
			notify: true
		},
		showSwiperPagination: {
            type: Boolean,
            value: true,
            notify: true
        },
		userInformationAvailable: {
			type: Boolean,
			value: true,
			notify: true
		},
		scheduleTransactionsStatus: {
			type: Array,
			value: ['PEN', 'AAC', 'ENT', 'FTD', 'ACT'],
			notify: true
		},
		scheduleBillsStatus: {
			type: Array,
			value: ['FTD', 'ACT'],
			notify: true
		},
		servicerequestStatus: {
			type: String,
			value: 'PEN'
		},
		billers: {
			type: Array,
			notify: true,
			observer: '_checkBillers'
		},
		loansWithAllAccounts: {
			type: Array,
			notify: true
		},
        engagements: {
            type: Array,
            notify: true,
            value: []
        }
	},

	_checkLastIndex: function (index, list) {
		if (index === list.length - 1)
			return true;
		return false;
	},

	_addClassBasedOnDevice: function (phone) {
		if (phone)
			return "horizontal-scroll flex-1 horizontal layout";
		return "";
	},

	_addClassBasedOnDeviceToCard: function (phone) {
		if (phone)
			return "round-icon-list-wrapper info-card cursor-pointer";
		return "mdl-grid info-card cursor-pointer";
	},

	_addClassBasedOnDeviceToDiv: function (phone) {
		if (phone)
			return "";
		return "mdl-cell mdl-cell--12-col";
	},
	_checkServiceRequestAndProductApplication: function (item) {
		if (item.servicerequest || item.productApplication)
			return true;
		return false;

	},
    _checkExperience: function(item) {
        if (item.data && item.data.interaction) {
            return true;
        }
        return false;
    },
	_checkServiceRequest: function (item) {
		if (item.servicerequest)
			return true;
		return false;
	},
	_checkProductApplication: function (item) {
		if (item.productApplication)
			return true;
		return false;
	},
	_createFinalList: function () {
		if (this.scheduletransactions != undefined && this.depositnearmaturity != undefined && this.loaneminearby != undefined && this.requests != undefined && this.schedulebills != undefined && this.schedulebillspresentment != undefined) {
			var temp = this.scheduletransactions;
			temp = temp.concat(this.loaneminearby);
			temp = temp.concat(this.depositnearmaturity);
			temp = temp.concat(this.schedulebills);
			temp = temp.concat(this.schedulebillspresentment);
			temp = temp.concat(this.applicationList);
			//Added for addition of engagement data
			temp = temp.concat(this.engagements);

			temp.sort(function (a, b) {
				return getNewDate(a.sortDate).getTime() - getNewDate(b.sortDate).getTime();
			});

			temp = temp.concat(this.requests);

			this.finalList = temp;
			if (this.finalList.length <= 0)
				this.userInformationAvailable = false;
			this.$$("#dashboard_info_spinner").active = false;
			this.userInformationLoader = false;
		}
	},

	_goToAction: function (e) {
		var detailsURL = e.model.item.navigateURL;
		var detailsNavigationData = e.model.item.navigateData;
		if (detailsNavigationData.isLoanNavigation) {
			this.getDataForIds(detailsNavigationData.loanAccountList, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/loanaccounts", function (list) {
				detailsNavigationData.loanAccountList = list;
				for (var i = 0; i < list.length; i++) {
					if (list.accountId === detailsNavigationData.selectedLoanAccount.accountId) {
						detailsNavigationData.selectedLoanAccount = list[i];
						break;
					}
				}
				window.oe_navigate_to(detailsURL, detailsNavigationData);
			});
		} else
			window.oe_navigate_to(detailsURL, detailsNavigationData);
	},

	_checkValue: function (value) {
		if (value == "") {
			return true;
		}
		return false;
	},

	scrollLeft: function () {
		var id = "#dashboard_info_scroll_div";
		this.$$(id).scrollLeft -= 320;
	},

	scrollRight: function () {
		var id = "#dashboard_info_scroll_div";
		this.$$(id).scrollLeft += 320;
	},

	ready: function () {
		this.nextNdays = config.SpeedBoat.App.dashboard.daysThresholdInformationSection;
		this.dateFormat = clientStorage.get(storageType.session, "dateFormat");
		this._getDepositNearMaturity = function (newVal) {
				var tempDepositNearMaturity = [];
				if (newVal != undefined) {
					for (var depositCounter = 0; depositCounter < newVal.length; depositCounter++) {
						var maturityDate = new Date(newVal[depositCounter].maturityDate);
						var futureDate = this.getFutureDate();
						if (futureDate.getTime() >= maturityDate.getTime() && maturityDate.getTime() >= this.getCurrentDate().getTime()) {
							var temp = Object.assign({}, newVal[depositCounter]);
							temp.displayName = temp.accountNickName;

							for (var j = 0; j < temp.balances.length; j++) {
								if (temp.balances[j].type == "maturityAmount" && temp.balances[j].amountDetails.amount !== undefined) {
									temp.displayAmount = currency.symbolize(temp.balances[j].amountDetails.currency + " " + temp.balances[j].amountDetails.amount);
									break;
								}
							}

							temp.displayDate = getNewDate(temp.maturityDate.toString().substring(0, 10));
							temp.sortDate = getNewDate(temp.maturityDate);
							temp.displayTag = temp.accountType.codeDescription;
							temp.displayRemark = getLabel("l_ScheduledOn");
							temp.displayAppFabName = temp.accountNickName;
							temp.displaySecondName = "";
							temp.navigateURL = "";
							temp.navigateData = {};
							tempDepositNearMaturity.push(temp);
						}
					}
					if (tempDepositNearMaturity.length > 0)
						this.depositnearmaturity = tempDepositNearMaturity;
					else
						this.depositnearmaturity = [];
				}
			},
			this._getLoansWithEMINearBy = function (newVal) {
				var tempLoanEMINearBy = [];
				if (newVal.length != undefined) {
					for (var loanCounter = 0; loanCounter < newVal.length; loanCounter++) {
						var installDate = getNewDate(newVal[loanCounter].nextInstallmentDueDate);
						var futureDate = this.getFutureDate();
						if (futureDate.getTime() >= installDate.getTime() && installDate.getTime() >= this.getCurrentDate().getTime()) {
							var temp = Object.assign({}, newVal[loanCounter]);
							temp.displayName = temp.accountNickName;

							for (var j = 0; j < temp.balances.length; j++) {
								if (temp.balances[j].type == "installmentAmount" && temp.balances[j].amountDetails.amount !== undefined) {
									temp.displayAmount = currency.symbolize(temp.balances[j].amountDetails.currency + " " + temp.balances[j].amountDetails.amount);
									break;
								}
							}

							temp.displayDate = getNewDate(temp.nextInstallmentDueDate.toString().substring(0, 10));
							temp.sortDate = getNewDate(temp.nextInstallmentDueDate);
							temp.displayTag = temp.accountType.codeDescription;
							temp.displayRemark = getLabel("l_ScheduledOn");
							temp.displayAppFabName = temp.accountNickName;
							temp.displaySecondName = "";
							temp.navigateURL = "/loanAcctLanding";
							temp.navigateData = {
								selectedLoanAccount: newVal[loanCounter],
								isLoanNavigation: true,
								loanAccountList: this.loansWithAllAccounts,
								selectedloanpage: 0
							};
							tempLoanEMINearBy.push(temp);
						}
					}
					if (tempLoanEMINearBy.length > 0)
						this.loaneminearby = tempLoanEMINearBy;
					else
						this.loaneminearby = [];
				}
			},
			this._getServiceRequest = function () {
				var ajaxCall = document.createElement('oe-ajax');
				var self = this;
				ajaxCall.contentType = "application/json";
				ajaxCall.handleAs = "json";
				ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/servicerequests?filter[where][requestId]=CHK&filter[where][status]=' + this.servicerequestStatus;
				ajaxCall.method = 'get';
				ajaxCall.addEventListener('response', function (event) {
                    if (event.detail.__data.xhr.getResponseHeader('engagements'))
                        self.handleExperiences(event.detail.__data.xhr.getResponseHeader('engagements'));
					if (event.detail.response.length > 0) {
						var requests = event.detail.response;
						for (var i = 0; i < requests.length; i++) {
							requests[i].servicerequest = true;
							requests[i].displayDate = "";
							requests[i].sortDate = "";
							requests[i].navigateURL = "/serviceslist";
							requests[i].navigateData = {
								serviceReq: requests[i]
							};
						}
						self.requests = requests;
					} else
						self.requests = [];
				});
				ajaxCall.addEventListener("error", function (e) {
					self.serviceError(e, 'servicerequest');
				});
				oeAjaxEventListner(ajaxCall);
				ajaxCall.generateRequest();
			},
			this.progressSteps = function (sr) {
				var tempProgressDetails = [];
				tempProgressDetails = [{
						"primaryText": "m_requested",
						"secondaryText": "",
					},
					{
						"primaryText": "m_processing",
						"secondaryText": ""
					},
					{
						"primaryText": "m_closure",
						"secondaryText": ""
					}
				]
				sr.requestStatus.cmCode == "WFR" ? tempProgressDetails.splice(1, 0, {
					"primaryText": "m_verified",
					"secondaryText": ""
				}) : ''
				this.progressDetails = tempProgressDetails;
				return this.progressDetails;
			},
			this.applicationProgressSteps = function (item) {
				var tempProgressDetails = [];
				tempProgressDetails = [{
						"primaryText": "l_Saved",
						"secondaryText": "",
					},
					{
						"primaryText": "l_submit",
						"secondaryText": ""
					},
					{
						"primaryText": "m_underProcessing",
						"secondaryText": ""
					},
					{
						"primaryText": "l_accountOpened",
						"secondaryText": ""
					}
				]
				item.applicationStatus == "AOR" ? tempProgressDetails.splice(3, 1, {
					"primaryText": "Rejected",
					"secondaryText": ""
				}) : ''
				if (item.applicationStatus == "AC") {
					tempProgressDetails = [];
					tempProgressDetails = [{
							"primaryText": "l_Saved",
							"secondaryText": "",
						},
						{
							"primaryText": "l_cancelled",
							"secondaryText": ""
						}
					]
				}

				this.progressDetails = tempProgressDetails;
				return this.progressDetails;
			},
			this.getIndex = function (status) {
				if (status == "WFR")
					return "2";
				else
					return "1";
			},
			this.getStatusIndex = function (status) {
				switch (status) {
					case "AS":
						return "0";
					case "AC":
						return "1";
					case "AD":
					case "AOR":
						return "3";
					case "AP":
						return "4";
					default:
						return "2";
				}
			},
			this._getTransfers = function () {
				var ajaxCall = document.createElement('oe-ajax');
				var self = this;
				ajaxCall.contentType = "application/json";
				ajaxCall.handleAs = "json";
				ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/transfers?filter[where][transactionDateFrom]=' +
					setBusinessDateString(this.getCurrentDate()) + '&filter[where][transactionDateTo]=' + setBusinessDateString(this.getFutureDate());
				ajaxCall.method = 'get';
				ajaxCall.addEventListener('response', function (event) {
					if (event.detail.response.length > 0) {
						var scheduletransactions = event.detail.response;
						var finalscheduletransactions = [];
						for (var i = 0; i < scheduletransactions.length; i++) {
							if (scheduletransactions[i].transactionStatus.cmCode && self.scheduleTransactionsStatus.indexOf(scheduletransactions[i].transactionStatus.cmCode) > -1) {
								scheduletransactions[i].displayName = scheduletransactions[i].toAccountNickname;
								scheduletransactions[i].displayAmount = currency.symbolize(scheduletransactions[i].transactionCurrency.cmCode + " " + scheduletransactions[i].totalTransactionAmount);
								scheduletransactions[i].displayDate = scheduletransactions[i].transactionDate;
								scheduletransactions[i].sortDate = getNewDate(scheduletransactions[i].transactionDate);
								scheduletransactions[i].displayTag = "";
								scheduletransactions[i].displaySecondName = "";
								scheduletransactions[i].displayRemark = getLabel("l_ScheduledOn");
								scheduletransactions[i].displayAppFabName = scheduletransactions[i].displayName;
								scheduletransactions[i].navigateURL = "";
								scheduletransactions[i].navigateData = {};
								finalscheduletransactions.push(scheduletransactions[i]);
							}
						}
						self.scheduletransactions = finalscheduletransactions;
					} else
						self.scheduletransactions = [];
				});
				ajaxCall.addEventListener("error", function (e) {
					self.serviceError(e, 'transfers');
				});
				oeAjaxEventListner(ajaxCall);
				ajaxCall.generateRequest();
			},
			this._getScheduledBills = function () {
				var ajaxCall = document.createElement('oe-ajax');
				var self = this;
				ajaxCall.contentType = "application/json";
				ajaxCall.handleAs = "json";
				ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/billpayments?filter[where][transactionDate][between][0]=' +
					setBusinessDateString(this.getCurrentDate()) + '&filter[where][transactionDate][between][1]=' + setBusinessDateString(this.getFutureDate());
				ajaxCall.method = 'get';
				ajaxCall.addEventListener('response', function (event) {
					if (event.detail.response.length > 0) {
						var schedulebills = event.detail.response;
						var finalschedulebills = [];
						for (var i = 0; i < schedulebills.length; i++) {
							if (schedulebills[i].frequencyType &&
								schedulebills[i].transactionStatus &&
								schedulebills[i].transactionStatus.cmCode &&
								(((schedulebills[i].frequencyType.id === 'R') || (schedulebills[i].frequencyType.id === 'O')) && self.scheduleBillsStatus.indexOf(schedulebills[i].transactionStatus.cmCode) > -1)) {

								schedulebills[i].displayName = "";
								schedulebills[i].navigateURL = "";
								schedulebills[i].navigateData = {};
								schedulebills[i].displayTag = "";

								for (var j = 0; j < self.billers.length; j++) {
									if (self.billers[j].registrationId == schedulebills[i].toAccountId) {
										schedulebills[i].displayName = self.billers[j].billerName;
										schedulebills[i].navigateURL = "/biller-details";
										schedulebills[i].navigateData = {
											registrationId: self.billers[j].registrationId,
											billId: schedulebills[i].referenceId,
											upcomingBillType: getLabel("l_Scheduled"),
											parsedBill: schedulebills[i]
										};
										if (self.billers[j].category != undefined && self.billers[j].category.codeDescription != undefined && self.billers[j].category.codeDescription != "")
											schedulebills[i].displayTag = self.billers[j].category.codeDescription;
									}
								}
								if (schedulebills[i].displayName == "")
									schedulebills[i].displaySecondName = schedulebills[i].toAccountNickname;
								else
									schedulebills[i].displaySecondName = " | " + schedulebills[i].toAccountNickname;
								schedulebills[i].displayAmount = currency.symbolize(schedulebills[i].transactionCurrency.cmCode + " " + schedulebills[i].totalTransactionAmount);
								schedulebills[i].displayDate = schedulebills[i].transactionDate;
								schedulebills[i].sortDate = getNewDate(schedulebills[i].transactionDate);
								schedulebills[i].displayRemark = getLabel("l_ScheduledOn");
								schedulebills[i].displayAppFabName = schedulebills[i].displayName;
								finalschedulebills.push(schedulebills[i]);
							}
						}
						self.schedulebills = finalschedulebills;
					} else
						self.schedulebills = [];
				});
				ajaxCall.addEventListener("error", function (e) {
					self.serviceError(e, 'bills');
				});
				oeAjaxEventListner(ajaxCall);
				ajaxCall.generateRequest();
			},
			this._getScheduledBillsPresentment = function () {
				var ajaxCall = document.createElement('oe-ajax');
				var self = this;
				ajaxCall.contentType = "application/json";
				ajaxCall.handleAs = "json";
				ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/billpresentment?filter[where][transactionDate][between][0]=' +
					setBusinessDateString(this.getCurrentDate()) + '&filter[where][transactionDate][between][1]=' + setBusinessDateString(this.getFutureDate());
				ajaxCall.method = 'get';
				ajaxCall.addEventListener('response', function (event) {
					if (event.detail.response.length > 0) {
						var schedulebillspresentment = event.detail.response;
						var finalschedulebillspresentment = [];
						for (var i = 0; i < schedulebillspresentment.length; i++) {
							if (schedulebillspresentment[i].frequencyType &&
								schedulebillspresentment[i].transactionStatus &&
								schedulebillspresentment[i].transactionStatus.cmCode &&
								(((schedulebillspresentment[i].frequencyType.id === 'R') || (schedulebillspresentment[i].frequencyType.id === 'O')) && self.scheduleBillsStatus.indexOf(schedulebillspresentment[i].transactionStatus.cmCode) > -1)) {

								schedulebillspresentment[i].displayName = "";
								schedulebillspresentment[i].navigateURL = "";
								schedulebillspresentment[i].navigateData = {};
								schedulebillspresentment[i].displayTag = "";
								for (var j = 0; j < self.billers.length; j++) {
									if (self.billers[j].registrationId == schedulebillspresentment[i].toAccountId) {
										schedulebillspresentment[i].displayName = self.billers[j].billerName;
										schedulebillspresentment[i].navigateURL = "/biller-details";
										schedulebillspresentment[i].navigateData = {
											registrationId: self.billers[j].registrationId,
											billId: schedulebillspresentment[i].referenceId,
											upcomingBillType: getLabel("l_Scheduled"),
											parsedBill: schedulebillspresentment[i]
										};
										if (self.billers[j].category != undefined && self.billers[j].category.codeDescription != undefined && self.billers[j].category.codeDescription != "")
											schedulebillspresentment[i].displayTag = self.billers[j].category.codeDescription;
									}
								}
								if (schedulebillspresentment[i].displayName == "")
									schedulebillspresentment[i].displaySecondName = schedulebillspresentment[i].toAccountNickname;
								else
									schedulebillspresentment[i].displaySecondName = " | " + schedulebillspresentment[i].toAccountNickname;
								schedulebillspresentment[i].displayAmount = currency.symbolize(schedulebillspresentment[i].transactionCurrency.cmCode + " " + schedulebillspresentment[i].totalTransactionAmount);
								schedulebillspresentment[i].displayDate = schedulebillspresentment[i].transactionDate;
								schedulebillspresentment[i].sortDate = getNewDate(schedulebillspresentment[i].transactionDate);
								schedulebillspresentment[i].displayRemark = getLabel("l_ScheduledOn");
								schedulebillspresentment[i].displayAppFabName = schedulebillspresentment[i].displayName;
								finalschedulebillspresentment.push(schedulebillspresentment[i]);
							}
						}
						self.schedulebillspresentment = finalschedulebillspresentment;
					} else
						self.schedulebillspresentment = [];
				});
				ajaxCall.addEventListener("error", function (e) {
					self.serviceError(e, 'billspresentment');
				});
				oeAjaxEventListner(ajaxCall);
				ajaxCall.generateRequest();
			},
			this.serviceError = function (err, type) {
				if (type === 'billspresentment')
					this.schedulebillspresentment = [];
				else if (type === 'bills')
					this.schedulebills = [];
				else if (type === 'servicerequest')
					this.requests = [];
				else if (type === 'transfers')
					this.scheduletransactions = [];
				else if (type === 'products')
					this.applicationList = [];
				//TODO// handling of OCH service error
			},
			this.getDatePart = function (date) {
				return date.toISOString().split('T')[0]
			},
			this.dateParse = function (d) {
				return d.toISOString().slice(0, 19) + 'Z';
			},
			this.getCurrentDate = function () {
				var currentDate = getNewDate();
				return currentDate;
			},
			this.getFutureDate = function () {
				var nextDate = getNewDate();
				nextDate.setDate(nextDate.getDate() + this.nextNdays);
				return nextDate;
			},
			this.getPastDate = function () {
				var lastDate = getNewDate();
				lastDate.setDate(lastDate.getDate() - this.nextNdays);
				return lastDate;
			},
			this._getProductApplications = function () {
				var ajaxCall = document.createElement('oe-ajax');
				var self = this;
				ajaxCall.contentType = "application/json";
				ajaxCall.handleAs = "json";
				ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/retailapplications';
				// ajaxCall.url = '/api/retailapplications/DEOS12648';
				ajaxCall.method = 'get';
				ajaxCall.addEventListener('response', function (event) {
					if (!_.isNil(event.detail.response) && !_.isEmpty(event.detail.response)) {
						var response = event.detail.response;
						if (_.isArray(event.detail.response)) {
							response = event.detail.response[0];
						}
						var applicationList = response.applicationDetails.userApplications;
						for (var i = 0; i < applicationList.length; i++) {
							applicationList[i].productApplication = true;
							applicationList[i].sortDate = getNewDate(applicationList[i].applicationCreationDate);
							applicationList[i].navigateURL = "/directbanking";
							var isExistingCustomer = "Y"
							var existingCustomerInfo = {};
							existingCustomerInfo.isExistingCustomer = isExistingCustomer;
							existingCustomerInfo.applicationInfo = applicationList[i];
							applicationList[i].navigateData = {
								existingCustomerInfo: existingCustomerInfo
							};
						}
						self.applicationList = applicationList;
					} else
						self.applicationList = [];
				});
				ajaxCall.addEventListener("error", function (e) {
					self.serviceError(e, 'products');
				});
				oeAjaxEventListner(ajaxCall);
				ajaxCall.generateRequest();
			}


	},
	onUserInformationLoaderChange: function () {
		if (this.userInformationLoader == false) {
			if (screen.width <= 767) {
				setTimeout(() => {
					// if (this.shadowRoot.querySelector('#my-wall-custom-slider')) {
					// 	this.shadowRoot.querySelector('#my-wall-custom-slider').shadowRoot.querySelector('.slider__dots').setAttribute("style", 'bottom: unset !important;left: unset !important;-webkit-transform: unset !important;transform: unset;right:7px;');

					// }


				}, 0);

			} else {
				//do nothing
			}
		}
	},
	attached: function () {
		this._getProductApplications();
		var prospectIndicator = clientStorage.get(storageType.session, "prospectIndicator");
		if (prospectIndicator == "Y") {
			var self = this;
			setTimeout(function () {
				self.requests = [];
				self.scheduletransactions = [];
				self.depositnearmaturity = [];
				self.loaneminearby = [];
				self.schedulebills = [];
				self.schedulebillspresentment = [];
			}, 50)
			return;
		}
		this._getServiceRequest();
		this._getTransfers();
	},
	_checkBillers: function () {
		if (this.billers != undefined) {
			if (!_.isEmpty(this.billers)) {
				this._getScheduledBills();
				this._getScheduledBillsPresentment();
			} else {
				this.schedulebills = [];
				this.schedulebillspresentment = [];
			}
		}
	},
	handleExperiences: function(engagements) {
        const self = this;
        var ajaxCall = document.createElement("oe-ajax");
        ajaxCall.url = "/api/Experiences/handleExperience?filter[where][engagements]=" + engagements + "&product=Speedboat&version=11.10.1";
        ajaxCall.method = "GET";
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.addEventListener('response', function(event) {
        
            var experiences = event.detail.response;
            var engagements = [];
            for (let i = 0; i < experiences.length; i++) {
                var experience = experiences[i];
                var components = experience.componentList;
        
                components.forEach((component) => {
                    if (component == "speed_myactions") {
                        engagements.push(experience);
                    }
                });
            }
        
            self.engagements = engagements;
        	self._createFinalList();
        });
        ajaxCall.addEventListener("error", function(e) {
            console.log("err");
        });
        ajaxCall.generateRequest();
    },
    
    // Method that redirects to selected navigation based on the action
    hanldeEngagementPrimaryClick(e){
        var primaryBtnData = e.model.item["primary_action"];
        var state = e.model.item.data.engagementData.info;
        //Redirects to navigation link
        window.oe_navigate_to_data(primaryBtnData.url, state);
    }
});
// window.addEventListener("WebComponentsReady", () => {
// 	if (screen.width <= 767) {
// 		if (this.shadowRoot.querySelector('#my-wall-custom-slider'))
// 			this.shadowRoot.querySelector('#my-wall-custom-slider').querySelector('.slider__dots').setAttribute("style", 'bottom: unset;left: unset;-webkit-transform: unset;transform: unset;left: unset;');			

// 	}
// 	else {
// 	   do nothing
// 	}
// });
